// src/selectors/issueEnrichers.ts
import { IIssueApi } from "@schemas/issueSchema";
import { IProjectMemberApiItem } from "@schemas/projectSchema";

export type IssueEnricher = (issue: IIssueApi, context: IEnrichmentContext) => IIssueApi;

export interface IEnrichmentContext {
  memberMap: Map<string, IProjectMemberApiItem>;
  // lägg till fler senare: tagMap, templateMap, etc.
}

export const enrichAssignedToWithDiscipline: IssueEnricher = (issue, ctx) => {
  const assignedTo = issue.assignedTo;
  if (!assignedTo?._id) return issue;

  const member = ctx.memberMap.get(assignedTo._id.toString());
  if (!member?.disciplin) return issue;

  return {
    ...issue,
    assignedTo: {
      ...assignedTo,
      discipline: member.disciplin,
    },
  };
};

// Pipeline – lägg till rad-lokala enrichers här. Board-wide formula enrichment körs batchat i selectors.
export const ENRICHERS: IssueEnricher[] = [enrichAssignedToWithDiscipline];
